(function () {
    'use strict';
    app.factory('authInterceptorService', ['$q', '$location', '$rootScope', '$window', 'AuthenticationService', function ($q, $location, $rootScope, $window, AuthenticationService) {

        var authInterceptorServiceFactory = {};

        var _request = function (config) {

            config.headers = config.headers || {};

            var authData = AuthenticationService.getTokenInfo();
            if (authData) {
                config.headers.Authorization = 'Bearer ' + authData;
            }

            return config;
        }

        var _responseError = function (rejection) {
            switch (rejection.status) {
                case 401:
                    AuthenticationService.removeToken();
                    $rootScope.$broadcast('logoutSuccess', 'true');
                    $location.path('/login');
                    break;
                case 404:
                    if ($rootScope.globalConfig.notfoundPage == undefined || $rootScope.globalConfig.notfoundPage == null || $rootScope.globalConfig.notfoundPage == '') {
                        $location.path("/notfound");
                    }
                    else {
                        $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.notfoundPage;
                    }
                    break;
                case 503:
                    if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                        $location.path("/error");
                    }
                    else {
                        $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                    }
                    break;
                default:
                    //  $location.path('/error');
                    break;
            }

            return $q.reject(rejection);
        }

        authInterceptorServiceFactory.request = _request;
        authInterceptorServiceFactory.responseError = _responseError;

        return authInterceptorServiceFactory;
    }]);
})();